import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { DETAIL_ACTIONS, DATE_TIME_FORMAT, SURCHARGE, ORDER } from '../../../../../../constants/Define';
import * as orderActions from './../../../../../../actions/orderAction';
import { OrderSurchargeItem } from '../../../../../../models/Order';
import * as Func from '../../../../../../helpers/functions';
import * as HMS from "../../../../common/component/Index";
import AntSelect, { AntOption } from '../../../../common/component/AntSelect'
import { checkUndefine, formatValidation } from "../../../../../../helpers/functions";
import Wrapper from './../../../../common/component/Wrapper';
import { isEqual, uniqBy } from 'lodash';
import moment from 'moment';
import { Input, Modal, message } from 'antd';

class SurchargeItemDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            surcharge: new OrderSurchargeItem(),
            isGetItem: false,
            validation: {},
            isSubmit: false,
            action: DETAIL_ACTIONS.CREATE,
        };
    }

    componentDidMount() {
        this.initDetail();
    }

    initDetail() {
        if (this.props.idItemSelect) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getSurchargeDetail(this.props.idItemSelect);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ action: DETAIL_ACTIONS.CREATE })
        if (nextProps.orderState.detail.surcharge && !isEqual(nextProps.orderState.detail.surcharge, this.props.orderState.detail.surcharge)) {
            this.setState({ surcharge: nextProps.orderState.detail.surcharge, action: nextProps.orderState.detail.surcharge.id ? 'UPDATE' : this.state.action });
        }

        if (nextProps.idItemSelect && !isEqual(nextProps.idItemSelect, this.props.idItemSelect)) {
            this.props.getSurchargeDetail(nextProps.idItemSelect);
        }
    }

    render() {
        const { t, visible } = this.props;
        const { action, validation, surcharge } = this.state;

        return (
            <Modal className="surcharge-detail"
                width={900}
                destroyOnClose={true}
                visible={visible}
                title={t(`item.surcharge.title`)}
                onOk={this.onSubmit} okText={action === DETAIL_ACTIONS.UPDATE ? t(`action.update`) : t(`action.create`)}
                onCancel={this.onCancel} cancelText={t(`action.cancel`)}
            >
                <Wrapper className="col-md-12">
                    <HMS.FormActionComponent
                        disabledFooter
                    >
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            isRequired={true}
                            isValidation={true}
                            dataValidation={surcharge.surchargeType}
                            validation={validation.surchargeType}
                            labelTitle={t(`item.surcharge.surchargeType`)}
                        >
                            <AntSelect className="select-site-code"
                                showArrow showSearch
                                placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.surcharge.surchargeType")).toLowerCase())}
                                value={surcharge.surchargeType ? t(`item.order.surchargeType.${surcharge.surchargeType}`) : null}
                                onChange={(e) => this.onChange('surchargeType', e)}
                                style={{ width: '100%' }}
                                filterOption={this.selectFilterSearch}
                            >
                                {Object.keys(SURCHARGE.TYPE).map(item => (
                                    <AntOption key={item} value={SURCHARGE.TYPE[item]}>{t(`item.order.surchargeType.${SURCHARGE.TYPE[item]}`)}</AntOption>
                                ))}
                            </AntSelect>
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            isRequired={true}
                            isValidation={true}
                            dataValidation={surcharge.name}
                            validation={validation.name}
                            labelTitle={t(`item.surcharge.name`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                value={checkUndefine(surcharge.name)} />
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            isRequired={true}
                            isValidation={true}
                            dataValidation={surcharge.transactionId}
                            validation={validation.transactionId}
                            labelTitle={t(`item.surcharge.transactionId`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`transactionId`} onChange={(e) => this.onChange('transactionId', e.target.value)}
                                value={Func.checkUndefine(surcharge.transactionId)} />
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            isRequired={true}
                            isValidation={true}
                            dataValidation={surcharge.operaBookingCode}
                            validation={validation.operaBookingCode}
                            labelTitle={t(`item.surcharge.operaBookingCode`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`operaBookingCode`} onChange={(e) => this.onChange('operaBookingCode', e.target.value)}
                                value={Func.checkUndefine(surcharge.operaBookingCode)} />
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            isRequired={true}
                            isValidation={true}
                            dataValidation={surcharge.amount}
                            validation={validation.amount}
                            labelTitle={t(`item.surcharge.amount`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`amount`} onChange={(e) => this.onChange('amount', e.target.value)}
                                value={surcharge.amount ? Func.formatMoney(surcharge.amount.toString()) : null} />
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            isRequired={true}
                            isValidation={true}
                            dataValidation={surcharge.paymentType}
                            validation={validation.paymentType}
                            labelTitle={t(`item.surcharge.paymentType`)}
                        >
                            <AntSelect className="select-site-code"
                                showArrow showSearch
                                placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.surcharge.paymentType")).toLowerCase())}
                                value={surcharge.paymentType ? t(`item.order.paymentTypes.${surcharge.paymentType}`) : null}
                                onChange={(e) => this.onChange('paymentType', e)}
                                style={{ width: '100%' }}
                                filterOption={this.selectFilterSearch}
                            >
                                {Object.keys(SURCHARGE.PAYMENT_TYPE).map(item => (
                                    <AntOption key={item} value={SURCHARGE.PAYMENT_TYPE[item]}>{t(`item.order.paymentTypes.${SURCHARGE.PAYMENT_TYPE[item]}`)}</AntOption>
                                ))}
                            </AntSelect>
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            dataValidation={surcharge.paymentDate}
                            validation={validation.paymentDate}
                            labelTitle={t(`item.surcharge.paymentDate`)}
                        >
                            <div className="row">
                                <div className="col-md-12">
                                    <HMS.DatePickerComponent
                                        onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                        name={'paymentDate'}
                                        format={DATE_TIME_FORMAT.SHORT_DATE}
                                        value={surcharge.paymentDate || null}
                                        placeholder=""
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        </HMS.FormWrapperInputComponent>
                        <HMS.FormWrapperInputComponent
                            className='col-md-6'
                            dataValidation={surcharge.note}
                            validation={validation.note}
                            labelTitle={t(`item.surcharge.note`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`note`} onChange={(e) => this.onChange('note', e.target.value)}
                                value={Func.checkUndefine(surcharge.note)} />
                        </HMS.FormWrapperInputComponent>

                    </HMS.FormActionComponent>
                </Wrapper>
            </Modal>
        )
    }

    onChange = (fieldName, value) => {
        const surcharge = this.state.surcharge;

        if (fieldName.name) {
            surcharge[fieldName.name] = fieldName.fullValue;
            this.setState({ surcharge });
        } else {
            surcharge[fieldName] = value;
            this.setState({ surcharge });
        }

        this.validate()
    };

    onSubmit = () => {
        const { surcharge, action } = this.state;
        surcharge.orderId = this.props.orderId;
        surcharge.itemVariantId = this.props.variantIdSelect;
        surcharge.listType = ORDER.TYPE_ITEM[this.props.orderItemType];
        if (this.validate()) {
            if(surcharge.amount <= 0) {
                message.error('Số tiền phải lớn hơn 0');
                return;
            }
            if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createSurchargeDetail(surcharge)
            } else {
                this.props.updateSurchargeDetail({ surcharge, props: this.props })
            }
            this.props.onSubmit();
            this.destroyData();
        }
    }


    onCancel = () => {
        this.props.onCancel();
        this.destroyData();
    }

    destroyData = () => {
        this.setState({surcharge: new OrderSurchargeItem()})
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.name`)),
                paymentType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.paymentType`)),
                surchargeType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.surchargeType`)),
                transactionId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.transactionId`)),
                operaBookingCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.operaBookingCode`)),
                amount: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.surcharge.fieldAmount`))
            },
            minValueNumber: {
                amount: t('validation.LessThenZero')
            }
        };
        let valueValidate = {
            minValueNumber: {
                amount: 0
            }
        };
        const result = Func.multipleValidate(this.state.surcharge, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSurchargeDetail: (id) => dispatch(orderActions.getSurchargeDetail(id)),
        setSurchargeDetail: (surcharge) => dispatch(orderActions.setSurchargeDetail(surcharge)),
        createSurchargeDetail: (surcharge) => dispatch(orderActions.createSurchargeDetail(surcharge)),
        updateSurchargeDetail: (surcharge) => dispatch(orderActions.updateSurchargeDetail(surcharge)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SurchargeItemDetail));